export default {
  routes: [
    {
      name: 'vendors',
      path: '/admin',
      component: () => import('./views/TheVendors.vue'),

    },

    {
      name: 'vendorsDev',
      path: '/development/vendors',
      component: () => import('./views/TheVendors.vue'),
    },

    {
      name: 'vendor',
      path: '/admin/settings/:id',
      component: () => import('./views/TheVendor.vue'),
    },

    {
      name: 'vendorByUuid',
      path: '/admin/settings/:uuid',
      component: () => import('./views/TheVendor.vue'),
    },

    {
      name: 'vendorSetting',
      path: '/admin/settings/:vendor_id/item/:setting_uuid/:setting_type',
      component: () => import('./views/TheVendorSetting.vue'),
    }
  ]
}
